import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyContentComponent } from './my-content.component';
import { TimeAgoModule } from 'src/app/pipes/time-ago/time-ago.module';
import { RouterModule } from '@angular/router';
import { ListsComponent } from './lists/lists.component';
import { ListersComponent } from './listers/listers.component';
import { PostsComponent } from '../posts/posts.component';
import { TranslateModule } from '@ngx-translate/core';
import {SharingOptionsModalComponent} from '../../pages/my-profile/components/sharing-options-modal/sharing-options-modal.component';



@NgModule({
  declarations: [
    MyContentComponent
  ],
    imports: [
        CommonModule,
        TimeAgoModule,
        RouterModule,
        ListsComponent,
        ListersComponent,
        PostsComponent,
        TranslateModule,
        SharingOptionsModalComponent
    ],
  exports: [
    MyContentComponent
  ]
})
export class MyContentModule { }
